import styled from "styled-components";

const SectionFilter = styled.div`
    display: flex;

    & input {
        margin-right: 10px;
    }
`;

export default SectionFilter;
